import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ppl-app-container',
  templateUrl: 'app-container.component.html',
  styleUrls: ['app-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PplAppContainerComponent {
}
